

const Error = ({ message }) => {
	return (
		<div className="text-red-600 font-semibold p-4 border border-red-300 bg-red-100 rounded">
			{message}
		</div>
	);
};

export default Error;
